import { gql } from '@apollo/client';

export const RATECARDS_QUERY = gql`
  query Ratecards {
    ratecards {
      id
      name
      s3Key
      uploadedBy
      createdAt
    }
  }
`;

export const RATECARD_QUERY = gql`
  query Ratecard($id: ID!) {
    ratecard(id: $id) {
      id
      name
      s3Key
      uploadedBy
      createdAt
      rows {
        ratecardName
        rateGroup
        groupType
        cost
        units
        min
        max
      }
    }
  }
`;

export const UPLOAD_RATECARD_MUTATION = gql`
  mutation UploadRatecard($name: String!, $s3Filename: String!) {
    uploadRatecard(name: $name, s3Filename: $s3Filename) {
      id
      name
      s3Key
      uploadedBy
      createdAt
    }
  }
`;

export const UPDATE_USER_RATECARD_MUTATION = gql`
  mutation UpdateUserRatecard($userId: ID!, $rateCardId: ID!) {
    updateUserRatecard(userId: $userId, rateCardId: $rateCardId) {
      message
    }
  }
`;

export const UPDATE_USER_PAYMENT_TYPE_MUTATION = gql`
  mutation UpdateUserPaymentType($userId: ID!, $paymentType: String!) {
    updateUserPaymentType(userId: $userId, paymentType: $paymentType) {
      message
    }
  }
`;
